import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import EditContractorModalV2 from "../../../AdminTasks/AdminContractors/EditContractorModalV2";

export default function ContractorSelector(props) {
  const { projectId, contractorId, setContractorId } = props;

  const [showModal_addSupplier, setShowModal_addSupplier] = useState(false);
  const toggleModal_addSupplier = () => setShowModal_addSupplier(!showModal_addSupplier);

  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[projectId] || null
  );
  const contractorOptions = useMemo(
    () => getProjContractorOptions(projContractorList || []),
    [projContractorList]
  );

  const [selectedContractor, setSelectedContractor] = useState(
    contractorId && contractorOptions
      ? contractorOptions.find((co) => co.value === contractorId) || null
      : null
  );

  useEffect(() => {
    const ctrToSelect =
      contractorId && contractorOptions
        ? contractorOptions.find((co) => co.value === contractorId) || null
        : null;
    if (ctrToSelect) setSelectedContractor(ctrToSelect);
  }, [contractorId, contractorOptions]);

  return (
    <React.Fragment>
      <div className="card mx-2 mb-2 bg-lightgray">
        <div className="card-body">
          <div className="form-row form-group mb-0">
            <label className="col-sm-3 col-form-label">
              <strong>Contractor:</strong>*
            </label>
            <div className="col-sm-6 my-auto">
              <Select
                name="contractorId"
                id="addLaborContractorId"
                value={selectedContractor}
                options={contractorOptions}
                onChange={(selected) => {
                  setSelectedContractor(selected);
                  setContractorId(selected ? selected.value : 0);
                }}
                placeholder="(Select a Contractor)"
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
              {!contractorId && (
                <span className="error-small">
                  <small>Required</small>
                </span>
              )}
            </div>
            <div className="col-sm-3">
              <button
                id="addLabor_addSupplier"
                name="addSupplier"
                onClick={toggleModal_addSupplier}
                className="btn btn-info"
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-1" />
                Add...
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal_addSupplier && (
        <EditContractorModalV2
          showModal={showModal_addSupplier}
          toggleModal={toggleModal_addSupplier}
          projectId={projectId}
          data={{ isNew: true, contractorId: null }}
          asSupplierOnly={true}
          submitCallback_new={(newContractorId) => setContractorId(newContractorId)}
        />
      )}
    </React.Fragment>
  );
}
